import { useQuery } from 'react-query'
import { CoolFarmService } from '~/api/services/coolFarm'
import { onError } from '~/utils/helpers'

const getCoolFarmFootprints = (data?) => useQuery(
  'cool-farm-footprints-data',
  () => CoolFarmService.getCoolFarmFootprints(data),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getCoolFarmOptions = (data?) => useQuery(
  'co2-footprints-data',
  () => CoolFarmService.getCoolFarmOptions(data),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getCoolFarmCount = (data?) => useQuery(
  'co2-footprints-count',
  () => CoolFarmService.getCoolFarmCount(data),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

export const CoolFarmQuery = {
  getCoolFarmFootprints,
  getCoolFarmCount,
  getCoolFarmOptions
}